import './index.css';

const DashboardContent = ({ children }) => {
    return (
        <div className="dashboard-content">
            {children}
        </div>
    )
}

export default DashboardContent;